import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';
import { map } from 'rxjs';
import { freePlanMaxSeats } from '../../../billing-consts';
import { calcIncludedSeatCount, isEnterprise, isFreeSubscription } from '../../../lib/subscription-helpers';
import { OrganizationService } from '../../../services/organization.service';
import { PricingService } from '../../../services/pricing.service';
import { StateService } from '../../../services/state.service';
import { SubscriptionService } from '../../../services/subscription.service';
import { CustomCurrencyPipe } from '../../../shared/pipes/custom-currency.pipe';

@Component({
  selector: 'app-team-invite-charge-text',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CustomCurrencyPipe, RouterLink],
  templateUrl: './team-invite-charge-text.component.html',
  styleUrl: './team-invite-charge-text.component.scss',
})
export class TeamInviteChargeTextComponent {
  public state = inject(StateService);
  private organizationService = inject(OrganizationService);
  private pricingService = inject(PricingService);
  private subscriptionService = inject(SubscriptionService);

  private seatAddonPrices = toSignal(this.pricingService.getPrices('seat_addon'));

  public seatAddonPrice = computed(() => {
    const prices = this.seatAddonPrices();
    const mainPrice = this.mainPrice();
    if (!mainPrice || !prices) return;
    const id = mainPrice.metadata.seat_addon_price_id;
    return prices.find(price => price.id === id);
  });

  subscription = toSignal(this.subscriptionService.getSubscription());
  isFree = computed(() => isFreeSubscription(this.subscription()));

  memberCount = toSignal(this.organizationService.getMembers().pipe(map(members => members.length)));
  inviteCount = toSignal(this.organizationService.getPendingInvites().pipe(map(invites => invites.length)));
  maxInviteCount = computed(() =>
    this.isFree() ? freePlanMaxSeats - this.memberCount() - this.inviteCount() : Infinity
  );
  canInvite = computed(() => this.maxInviteCount() > 0);
  includedInviteCount = computed(() => {
    const memberCount = this.memberCount();
    const mainPrice = this.mainPrice();
    if (!mainPrice) return 0;
    return calcIncludedSeatCount(mainPrice) - memberCount;
  });
  mainPrice = toSignal(this.subscriptionService.getMainPrice());
  isEnterprise = computed(() => isEnterprise(this.mainPrice()));
}
